/**
 * About hero: the full-viewport section that hosts the timeline slider. The
 * `.animation-on-load-01` wrapper is revealed by the generic page-load sequence
 * (handled globally by SiteAnimations); the slider motion lives in
 * <AboutSlider>.
 */
import type { FC } from 'react'

import { AboutSlider } from '@/components/about/about-slider'

export const AboutHero: FC = () => {
    return (
        <div className='section about-me-section'>
            <div className='about-hero-container'>
                <div className='container about-container'>
                    <div className='about-slider-container'>
                        <div className='animation-on-load-01 slide'>
                            <AboutSlider />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
